export interface OnboardingData {
  cp_onboarding_status?: string | null;
  cp_onboarding_completed_at?: string | null;
  cp_customer_group_id?: string | null;
  cp_industry_id?: string | null;
  cp_company_size?: string | null;
  cp_job_position_id?: string | null;
  cp_country_code?: string | null;
  cp_application_id?: string | null;
  cp_buying_journey_phase?: string | null;
  cp_updated_at?: string | null;
}

export interface OnboardingInput {
  cp_onboarding_status?: string | null;
  cp_customer_group_id?: string | null;
  cp_industry_id?: string | null;
  cp_company_size?: string | null;
  cp_job_position_id?: string | null;
  cp_country_code?: string | null;
  cp_application_id?: string | null;
  cp_buying_journey_phase?: string | null;
}

export interface OnboardingAnswers {
  industryId: string | null;
  companySizeId: string | null;
  customerGroupId: string | null;
  jobPositionId: string | null;
  buyingJourneyPhase: string | null;
  applicationIds: string[];
}

export const DEFAULT_ONBOARDING_ANSWERS: OnboardingAnswers = {
  industryId: null,
  companySizeId: null,
  customerGroupId: null,
  jobPositionId: null,
  buyingJourneyPhase: null,
  applicationIds: []
};

export enum OnboardingStep {
  Intro = 'intro',
  Industry = 'industry',
  Role = 'role',
  Position = 'position',
  BuyingPhase = 'buyingPhase',
  Applications = 'applications',
  Success = 'success'
}

export const ONBOARDING_STEP_ORDER: OnboardingStep[] = [
  OnboardingStep.Intro,
  OnboardingStep.Industry,
  OnboardingStep.Applications,
  OnboardingStep.Role,
  OnboardingStep.BuyingPhase,
  OnboardingStep.Position,
  OnboardingStep.Success
];

/** Form steps shown in the progress bar (excludes intro and success). */
export const ONBOARDING_FORM_STEPS: OnboardingStep[] =
  ONBOARDING_STEP_ORDER.filter(
    (step: OnboardingStep) =>
      step !== OnboardingStep.Intro && step !== OnboardingStep.Success
  );

export const ONBOARDING_STATUS_COMPLETED = 'completed';
export const ONBOARDING_STATUS_IN_PROGRESS = 'in_progress';
export const ONBOARDING_STATUS_PENDING = 'pending';

/** Reserved for future welcome-screen variants (new registration vs returning user). */
export type OnboardingWelcomeVariant =
  'newRegistration' | 'returningIncomplete';
